import React, { useCallback, useState } from "react";
import { Link } from "react-router-dom";
import cn from "clsx";
import { isMobile } from "@/util";
import { getRedirectionUrl, isLinkStartsFromHTTPS } from "@/util/common";
import BannerIntersectionObserver from "../../banner/bannerIntersectionObserver";
import { imagePlaceholderColors, ImagePlaceholderType } from "@/components/img";
import "./style.scss";

const stylesForVideo = (
  { hover, ...restStyles },
  { hovered, imageWidth, marginForImage, hoverValues }
) => ({
  ...restStyles,
  ...(!isMobile.any() && hovered && hoverValues && hover),
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flex: `0 0 calc(${imageWidth}% - ${marginForImage}px)`
});

const DynamicVideo = ({
  data,
  imageWidth = 100,
  marginForImage = 0,
  styles,
  redirectionPath,
  linkTarget,
  index,
  dataForAnalytic,
  imagePlaceholderType = "SINGLE_BANNER" as ImagePlaceholderType
}) => {
  const [videoLoading, setVideoLoading] = useState(true);
  const [hovered, setHovered] = useState(false);
  const hoverValues = styles.hoverValues?.transform;
  const placeholderColor = imagePlaceholderColors[imagePlaceholderType];

  const hideVideoPlaceholder = useCallback(() => {
    setVideoLoading(false);
  }, []);

  return (
    <div
      style={stylesForVideo(styles, {
        hovered,
        imageWidth,
        marginForImage,
        hoverValues
      })}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      <div className="video-wrapper">
        <div
          style={{
            position: "relative",
            paddingBottom: `${data.ratio}%`
          }}
        >
          <Link
            className={cn("video-container", {
              "disabled-link": !data.redirectionLink
            })}
            to={getRedirectionUrl(
              isLinkStartsFromHTTPS(redirectionPath),
              redirectionPath
            )}
            target={linkTarget}
            data-banner-link={data.redirectionLink}
            data-banner-index={index}
          >
            {data.videoUrl && videoLoading && (
              <div
                className="video-placeholder"
                style={{ backgroundColor: placeholderColor }}
                aria-busy="true"
                aria-label="Loading video"
              />
            )}
            <BannerIntersectionObserver data={dataForAnalytic}>
              <video
                autoPlay
                loop
                muted
                playsInline
                width="100%"
                onLoadedData={hideVideoPlaceholder}
                onError={hideVideoPlaceholder}
              >
                <source src={data.videoUrl} type="video/mp4" />
                Your browser does not support HTML video.
              </video>
            </BannerIntersectionObserver>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default DynamicVideo;
